import { AlertCircle, Loader2 } from "lucide-react";
import type { CollectionFile } from "./utils";

export interface DeleteFileModalProps {
  open: boolean;
  file: CollectionFile | null;
  onClose: () => void;
  onConfirm: () => void;
  isDeleting: boolean;
}

export function DeleteFileModal({ open, file, onClose, onConfirm, isDeleting }: Readonly<DeleteFileModalProps>) {
  if (!open || !file) return null;

  return (
    <div className="fixed inset-0 bg-surface-overlay backdrop-blur-xs flex items-center justify-center z-50 p-4">
      <div className="bg-surface-primary border border-border-primary rounded-xl w-full max-w-md">
        <div className="p-6">
          <div className="flex items-center gap-3 mb-4">
            <div className="h-10 w-10 rounded-lg bg-red-500/20 flex items-center justify-center">
              <AlertCircle className="h-5 w-5 text-red-400" />
            </div>
            <h2 className="text-lg font-semibold text-content-primary">Delete File</h2>
          </div>
          <p className="text-content-tertiary mb-6">
            Are you sure you want to delete{" "}
            <span className="text-content-primary font-medium break-all line-clamp-2" title={file.filename}>
              {file.filename}
            </span>
            {"? This action cannot be undone."}
          </p>
          <div className="flex items-center justify-end gap-3">
            <button
              onClick={onClose}
              disabled={isDeleting}
              className="px-4 py-2 text-content-secondary hover:text-content-primary transition-colors disabled:opacity-50"
            >
              Cancel
            </button>
            <button
              onClick={onConfirm}
              disabled={isDeleting}
              className="flex items-center gap-2 px-4 py-2 bg-red-500 hover:bg-red-600 text-white rounded-lg font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isDeleting && <Loader2 className="h-4 w-4 animate-spin" />}
              {isDeleting ? "Deleting..." : "Delete"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
